import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/'

import Home from '../views/Home.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/printmap/:id/:zoom/:scale/:labels/:labelsize/:labelcolor/:pointOpacity/:pointStroke/:sheet/:legendScale/:token',
      name: 'printmap',
      component: () => import(/* webpackChunkName: "printmap" */ '../views/PrintMap.vue')
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ '../views/Client.vue'),
      meta: { auth: 'admin' },
      children: [
        {
          path: 'cifuri',
          name: 'cifuri',
          component: () => import(/* webpackChunkName: "cifuri" */ '../views/admin/Cifuri.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'clasificatie-bugetara',
          name: 'clasificatie-bugetara',
          component: () => import(/* webpackChunkName: "clasificatie" */ '../views/admin/Clasificatie.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'rapoarte-indicatori',
          name: 'rapoarte-indicatori',
          component: () => import(/* webpackChunkName: "indicatori" */ '../views/admin/Indicatori.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'dictionar',
          name: 'dictionar',
          component: () => import(/* webpackChunkName: "dictionar" */ '../views/admin/Dictionar.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'sistem-de-verificare',
          name: 'sistem-de-verificare',
          component: () => import(/* webpackChunkName: "verificare" */ '../views/admin/Verificare.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'date-financiare',
          name: 'date-financiare',
          component: () => import(/* webpackChunkName: "datefinanciare" */ '../views/admin/Date.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'utilizatori',
          name: 'users',
          component: () => import(/* webpackChunkName: "users" */ '../views/admin/Users.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'judete',
          name: 'judete',
          component: () => import(/* webpackChunkName: "judete" */ '../views/admin/Judete.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'all',
          name: 'all',
          component: () => import(/* webpackChunkName: "allapl" */ '../views/admin/AllApl.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'municipii',
          name: 'municipii',
          component: () => import(/* webpackChunkName: "municipii" */ '../views/admin/Municipii.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'orase',
          name: 'orase',
          component: () => import(/* webpackChunkName: "orase" */ '../views/admin/Orase.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'comune',
          name: 'comune',
          component: () => import(/* webpackChunkName: "comune" */ '../views/admin/Comune.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'liste',
          name: 'liste',
          component: () => import(/* webpackChunkName: "lists" */ '../views/admin/Lists.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'rapoarte',
          name: 'rapoarte',
          component: () => import(/* webpackChunkName: "rapoarte" */ '../views/admin/Rapoarte.vue'),
          meta: { auth: 'admin' }
        },
        {
          path: 'access',
          name: 'access',
          component: () => import(/* webpackChunkName: "access" */ '../views/admin/Access.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'clasificatiecheck',
          name: 'clasificatiecheck',
          component: () => import(/* webpackChunkName: "clasificatiecheck" */ '../views/admin/ClasificatieCheck.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'automation',
          name: 'automation',
          component: () => import(/* webpackChunkName: "automation" */ '../views/admin/Automation.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'mfdata',
          name: 'mfdata',
          component: () => import(/* webpackChunkName: "mfdata" */ '../views/admin/MFData.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'storage',
          name: 'storage',
          component: () => import(/* webpackChunkName: "storage" */ '../views/admin/Storage.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'download',
          name: 'download',
          component: () => import(/* webpackChunkName: "download" */ '../views/admin/Download.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'maps',
          name: 'maps',
          component: () => import(/* webpackChunkName: "maps" */ '../views/admin/Maps.vue'),
          meta: { auth: ['admin'] }
        },

        {
          path: 'rapoarte-judete',
          name: 'rapoarte-judete-admin',
          component: () => import(/* webpackChunkName: "judeteclientadmin" */ '../views/client/Judete.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'rapoarte-municipii',
          name: 'rapoarte-municipii-admin',
          component: () => import(/* webpackChunkName: "municipiiclientadmin" */ '../views/client/Municipii.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'rapoarte-orase',
          name: 'rapoarte-orase-admin',
          component: () => import(/* webpackChunkName: "oraseclientadmin" */ '../views/client/Orase.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'rapoarte-comune',
          name: 'rapoarte-comune-admin',
          component: () => import(/* webpackChunkName: "comuneclientadmin" */ '../views/client/Comune.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'rapoarte-agregate',
          name: 'rapoarte-agregate-admin',
          component: () => import(/* webpackChunkName: "agregateclientadmin" */ '../views/client/RapoarteAgregate.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'rapoarte-interactive',
          name: 'rapoarte-interactive-admin',
          component: () => import(/* webpackChunkName: "interactiveclientadmin" */ '../views/client/RapoarteInteractive.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        },
        {
          path: 'harti',
          name: 'harti-admin',
          component: () => import(/* webpackChunkName: "harticlientadmin" */ '../views/client/Harti.vue'),
          meta: { auth: ['admin', 'limitedadmin'] }
        }
      ]
    },
    {
      path: '/dashboard-client',
      name: 'dashboard-client',
      component: () => import(/* webpackChunkName: "dashboardclient" */ '../views/Client.vue'),
      meta: { auth: ['client', 'public', 'limitedadmin'] },
      children: [
        {
          path: 'judete-client',
          name: 'judete-client',
          component: () => import(/* webpackChunkName: "judeteclient" */ '../views/client/Judete.vue'),
          meta: { auth: ['client', 'public', 'limitedadmin'] }
        },
        {
          path: 'municipii-client',
          name: 'municipii-client',
          component: () => import(/* webpackChunkName: "municipiiclient" */ '../views/client/Municipii.vue'),
          meta: { auth: ['client', 'public', 'limitedadmin'] }
        },
        {
          path: 'orase-client',
          name: 'orase-client',
          component: () => import(/* webpackChunkName: "oraseclient" */ '../views/client/Orase.vue'),
          meta: { auth: ['client', 'public', 'limitedadmin'] }
        },
        {
          path: 'comune-client',
          name: 'comune-client',
          component: () => import(/* webpackChunkName: "comuneclient" */ '../views/client/Comune.vue'),
          meta: { auth: ['client', 'public', 'limitedadmin'] }
        },
        {
          path: 'rapoarte-agregate',
          name: 'rapoarte-agregate',
          component: () => import(/* webpackChunkName: "agregateclient" */ '../views/client/RapoarteAgregate.vue'),
          meta: { auth: ['client', 'public', 'limitedadmin'] }
        },
        {
          path: 'rapoarte-interactive',
          name: 'rapoarte-interactive',
          component: () => import(/* webpackChunkName: "interactiveclient" */ '../views/client/RapoarteInteractive.vue'),
          meta: { auth: ['limitedadmin'] }
        },
        {
          path: 'harti',
          name: 'harti',
          component: () => import(/* webpackChunkName: "harticlient" */ '../views/client/Harti.vue'),
          meta: { auth: ['client'] }
        }
      ]
    }
  ]
})

let loads = 0

router.beforeEach((to, from, next) => {
  const auth = to.meta.auth || null
  const user = store.getters.user
  if (auth) {
    if (!user) {
      store.dispatch('login').then(usr => {
        proceed(usr)
      }).catch(err => {
        console.log(err)
        next({ name: 'home' })
      })
    } else {
      proceed(user)
    }
  } else {
    if (from.name === null && to.name === 'home') { // initial app load
      if (loads === 0) {
        loads++
        if (user) { // this would never get hit
          if (user.admin) {
            next({ name: 'dashboard' })
          } else {
            next({ name: 'municipii-client' })
          }
        }
        next({ name: 'municipii-client' })
      } else {
        next()
      }
    }
    next()
  }

  function proceed (user) {
    let isAllowed = false

    if (user) {
      if (user.admin) isAllowed = true
      else if (Array.isArray(auth)) {
        isAllowed = auth.reduce((agg, item) => {
          if (user[item]) agg = true
          return agg
        }, false)
      } else if (user[auth]) isAllowed = true
    }
    // debugger
    if (isAllowed) next()
    else next({ name: 'home' })
  }
})

export default router
